export default __webpack_public_path__ + "static/media/6.bcf5b38c.jpg";